import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from './styles';

function Container({ children, as, className }) {
  return (
    <Grid as={as} className={className}>
      {children}
    </Grid>
  );
}

Container.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  as: PropTypes.string,
};

Container.defaultProps = {
  className: null,
  as: 'div',
};

export default Container;
